import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
}
export function Modal({
  open,
  onClose,
  title,
  children,
  size = 'md'
}: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-660">
      {open && <motion.div className="fixed inset-0 z-[120] flex items-center justify-center p-4 sm:p-6" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="dialog" aria-modal="true" aria-label={title} data-id="element-661">
          <div className="absolute inset-0 bg-navy-deep/70 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-662" />
          <motion.div initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className={`relative bg-white border border-slate-200 rounded-md shadow-2xl w-full ${size === 'lg' ? 'max-w-3xl' : 'max-w-xl'} max-h-[90vh] overflow-y-auto`} data-id="element-663">
            <div className="sticky top-0 bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between z-10" data-id="element-664">
              <h2 className="font-serif text-lg text-navy-deep" data-id="element-665">{title}</h2>
              <button type="button" onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-sm text-slate-500 hover:bg-slate-100" aria-label="Close" data-id="element-666">
                <XIcon className="w-4 h-4" data-id="element-667" />
              </button>
            </div>
            <div className="px-6 py-6" data-id="element-668">{children}</div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}